var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Flex, P } from '@tpr/core';
import { Form, renderFields } from '@tpr/forms';
import { useTrusteeContext } from '../../context';
import { Footer } from '../../../components/card';
import { Content } from '../../../components/content';
import { Breadcrumbs } from '../../../components/breadcrumbs';
import { ArrowButton } from '../../../../buttons/buttons';
import { cardType } from '../../../common/interfaces';
var getDescriptionFields = function (_a) {
    var fields = _a.fields;
    return [
        {
            type: 'radio',
            name: 'trusteeType',
            value: 'member-nominated',
            label: fields.trusteeType.labels.memberNominated,
            cfg: { mb: 2 },
        },
        {
            type: 'radio',
            name: 'trusteeType',
            value: 'employer-appointed',
            label: fields.trusteeType.labels.employerAppointed,
            cfg: { mb: 2 },
        },
        {
            type: 'radio',
            name: 'trusteeType',
            value: 'regulator-appointed',
            label: fields.trusteeType.labels.regulatorAppointed,
            cfg: { mb: 2 },
        },
        {
            type: 'radio',
            name: 'trusteeType',
            value: 'other',
            label: fields.trusteeType.labels.other,
            cfg: { mb: 4 },
        },
    ];
};
var getIndividualFields = function (_a) {
    var fields = _a.fields;
    return [
        {
            type: 'radio',
            name: 'isProfessionalTrustee',
            value: 'yes',
            label: fields.isProfessionalTrustee.labels.isProfessionalTrusteeYes,
        },
        {
            type: 'radio',
            name: 'isProfessionalTrustee',
            value: 'no',
            label: fields.isProfessionalTrustee.labels.isProfessionalTrusteeNo,
            cfg: { ml: 3 },
        },
    ];
};
var getBreadcrumbLinks = function (_a) {
    var breadcrumbs = _a.breadcrumbs;
    return [
        {
            to: 'BACK',
            underline: true,
            name: breadcrumbs.link1,
        },
        {
            name: breadcrumbs.link2,
            disabled: true,
        },
    ];
};
var Type = function () {
    var _a = useTrusteeContext(), current = _a.current, send = _a.send, i18n = _a.i18n;
    var descriptionFields = getDescriptionFields(i18n.type);
    var individualFields = getIndividualFields(i18n.type);
    var breadcrumbLinks = getBreadcrumbLinks(i18n.type);
    var _b = current.context, trustee = _b.trustee, loading = _b.loading;
    var onSubmit = function (values) {
        send('SAVE', {
            values: __assign(__assign({}, values), { isProfessionalTrustee: values.isProfessionalTrustee === 'yes' ? true : false }),
        });
    };
    return (React.createElement(Content, { type: cardType.trustee, title: "Type of trustee", loading: loading, breadcrumbs: function () { return React.createElement(Breadcrumbs, { links: breadcrumbLinks, send: send }); } },
        React.createElement(Form, { onSubmit: onSubmit, initialValues: {
                trusteeType: trustee.trusteeType,
                isProfessionalTrustee: trustee.isProfessionalTrustee ? 'yes' : 'no',
            } }, function (_a) {
            var handleSubmit = _a.handleSubmit;
            return (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(Flex, { cfg: { flexDirection: 'column' } },
                    React.createElement(P, { cfg: { mb: 1, fontWeight: 3 } }, "Select the option that best describes the type of trustee."),
                    renderFields(descriptionFields)),
                React.createElement(P, { cfg: { my: 1, fontWeight: 3 } }, "Is this individual a professional trustee?"),
                React.createElement(Flex, null, renderFields(individualFields)),
                React.createElement(Footer, null,
                    React.createElement(ArrowButton, { intent: "special", pointsTo: "up", iconSide: "right", type: "submit", title: "Save and close", disabled: loading }))));
        })));
};
export default Type;
//# sourceMappingURL=type.js.map